import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section>
      <div className="max-w-[1200px] mx-auto px-6 py-20 md:py-24 text-center">
        <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight">Stop building KYC. Ship product.</h2>
        <p className="text-zinc-600 mt-4 max-w-xl mx-auto">Create your first KYC verification flow in under 3 minutes.</p>
        <Link to="/signup" data-testid="footer-signup-cta"
          className="inline-flex mt-8 items-center gap-2 bg-black text-white px-6 py-3 rounded-sm hover:bg-zinc-800 text-sm font-medium">
          Create your workspace <ArrowRight className="w-4 h-4" strokeWidth={2}/>
        </Link>
      </div>
    </section>
  );
}
